var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0508,
    cy: 15.5356,
    r: 14.9492,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2753 14.7058C13.2019 14.6985 13.1138 14.6985 13.033 14.7058C11.2859 14.6471 9.89844 13.2156 9.89844 11.4537C9.89844 9.6552 11.352 8.19434 13.1578 8.19434C14.9564 8.19434 16.4172 9.6552 16.4172 11.4537C16.4099 13.2156 15.0225 14.6471 13.2753 14.7058Z",
    fill: "#FFF500",
    stroke: "#FFF500",
    strokeWidth: 1.03638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5971 9.66296C20.0213 9.66296 21.1665 10.8155 21.1665 12.2323C21.1665 13.6198 20.0653 14.7503 18.6926 14.8017C18.6338 14.7943 18.5678 14.7943 18.5017 14.8017",
    stroke: "#FFF500",
    strokeWidth: 1.03638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60436 17.415C7.82784 18.6043 7.82784 20.5423 9.60436 21.7242C11.6231 23.0749 14.9339 23.0749 16.9527 21.7242C18.7292 20.535 18.7292 18.5969 16.9527 17.415C14.9413 16.0716 11.6305 16.0716 9.60436 17.415Z",
    fill: "#FFF500",
    stroke: "#FFF500",
    strokeWidth: 1.03638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0176 21.7746C20.5461 21.6645 21.0453 21.4516 21.4564 21.1359C22.6016 20.277 22.6016 18.8602 21.4564 18.0013C21.0527 17.693 20.5608 17.4875 20.0396 17.37",
    stroke: "#FFF500",
    strokeWidth: 1.03638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.fbbfb533fc24c562888c4acad9c90340.svg";
export { ForwardRef as ReactComponent };